import { IOfferBuilding } from '../../types/offers';

export const getLift = (building?: IOfferBuilding): string => {
  if (building) {
    if (building.cargoLiftsCount) {
      return 'лифт грузовой';
    } else if (building.passengerLiftsCount) {
      return 'лифт пассажирский';
    }
  }

  return 'нет лифта';
};
